<template>
  <nav class="pestanas-estado" role="tablist" :aria-label="titulo">
    <router-link
      v-for="p in pestanas"
      :key="p.ruta"
      :to="p.ruta"
      class="pestanas-estado__tab"
      :class="{ 'pestanas-estado__tab--activa': activa(p) }"
      role="tab"
      :aria-selected="activa(p) ? 'true' : 'false'"
      replace
    >
      <v-icon small class="mr-1">{{ p.icono }}</v-icon>{{ p.texto }}
    </router-link>
  </nav>
</template>

<script>
/**
 * Los listados por estado (egresos, notas crédito) en pestañas, como en el panel de Nubempresa:
 * un solo lugar y un clic para pasar de borradores a aprobados o anulados. Cada pestaña sigue
 * siendo su propia pantalla, así que filtros, permisos y botones no cambian.
 */
const GRUPOS = {
  egresos: {
    titulo: "Egresos por estado",
    pestanas: [
      { texto: "Borradores", ruta: "/pos/expense-draft", icono: "mdi-pencil-outline" },
      { texto: "Aprobados", ruta: "/pos/expense-finalized", icono: "mdi-check-circle-outline" },
      { texto: "Anulados", ruta: "/pos/expense-annulled", icono: "mdi-cancel" },
    ],
  },
  "notas-factura": {
    titulo: "Notas crédito de factura por estado",
    pestanas: [
      { texto: "Aprobadas", ruta: "/pos/credit-note-finalized", icono: "mdi-check-circle-outline" },
      { texto: "Anuladas", ruta: "/pos/credit-note-annulled", icono: "mdi-cancel" },
    ],
  },
  notas: {
    titulo: "Notas crédito DE por estado",
    pestanas: [
      { texto: "Aprobadas", ruta: "/pos/de-credit-note-finalized", icono: "mdi-check-circle-outline" },
      { texto: "Anuladas", ruta: "/pos/de-credit-note-annulled", icono: "mdi-cancel" },
    ],
  },
};

export default {
  name: "PestanasEstado",
  props: { grupo: { type: String, required: true } },
  computed: {
    titulo() {
      return (GRUPOS[this.grupo] || {}).titulo || "";
    },
    pestanas() {
      return (GRUPOS[this.grupo] || {}).pestanas || [];
    },
  },
  methods: {
    activa(p) {
      return this.$route.path === p.ruta;
    },
  },
};
</script>

<style scoped>
.pestanas-estado {
  display: flex;
  gap: 4px;
  margin: 8px 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow-x: auto;
}
.pestanas-estado__tab {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #5f6368;
  text-decoration: none;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}
@media (max-width: 600px) {
  .pestanas-estado {
    margin: 8px 12px 0;
    gap: 0;
  }
  .pestanas-estado__tab {
    flex: 1;
    justify-content: center;
    padding: 10px 6px;
    font-size: 13px;
  }
  .pestanas-estado__tab .v-icon {
    display: none;
  }
}
.pestanas-estado__tab:hover {
  color: #24a9e1;
}
.pestanas-estado__tab--activa {
  color: #24a9e1;
  border-bottom-color: #24a9e1;
  font-weight: 600;
}
</style>
